export const CHECKOUT_BREAKDOWN = "Checkout breakdown";

export const TRIP_TOTAL_BREAKDOWN_TEXT = "Trip total";

export const AMOUNT_DUE = "Amount due";
